import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  container: {
    ...dFlex('unset', 'unset'),
    flexDirection: 'column',
    gap: '8px',
  },
  button: {
    padding: '8px',
    borderRadius: theme.borderRadius.md,
    border: `2px solid #000000`,
    background: '#000000',
    ...dFlex('space-between', 'center'),

    '&:hover': {
      background: '#000000',
      border: `2px solid #000000`,
    },

    '& .MuiSvgIcon-root': {
      color: '#000000',
      width: 22,
    },

    '&:disabled': {
      opacity: 0.4,
      pointerEvents: 'none',
    },
  },
  activeButton: {
    border: `2px solid #000000`,

    '&:hover': {
      background: '#000000',
      border: `2px solid #000000`,
    },
  },
  row: {
    ...dFlex('unset', 'center'),
    gap: '16px',
  },
  tag: {
    background: '#000000',
    borderRadius: theme.borderRadius.sm,
    padding: '4px 8px',
  },
  logo: {
    borderRadius: '8px',
    width: '48px !important',
    height: '48px !important',
  },
}));

export default useStyles;
